import $ from 'jquery';
import Plyr from 'plyr';


function videoBlock() {
  $('.video-block:not(.video-block--popup) .video').each(function () {
    const videoElement = $(this).get(0)
    let poster = $(this).data('poster');
    let hideControls = $(this).hasClass('hide-controls');
    if ($(this).hasClass('video--oembed')) {
      const player = new Plyr(videoElement, {
        controls: hideControls?[]:['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        autoplay: hideControls?true:false,
        vimeo: { autoplay: false },
        youtube: { autoplay: false },
        fullscreen: { enabled: false }
      })

      // Customize the Plyr controls
      player.on('ready', () => {

        $('.btn-close').on('click', function () {
          player.pause()
        })
        $('.modal').on('click', function (event) {
          // Check if the click occurred outside of .modal-content
          if (!$(event.target).closest('.modal-content').length) {
            player.pause()
          }
        })

        $('.video').on('click touchstart', function (event) {
          event.preventDefault()
          event.stopPropagation()
          if (player.paused) {
            player.play()
          } else {
            player.pause()
          }
        })


      })
      if (poster) player.poster = poster;
      return player
    } else {

      let player = new Plyr($(this).get(0), {
        controls: hideControls?[]:['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        autoplay: hideControls?true:false,
        vimeo: { autoplay: false },
        youtube: { autoplay: false },
        fullscreen: { enabled: false }
      });
      if (poster) player.poster = poster;
      player.on('ready', () => {
        if(hideControls){
          player.muted = true;
          player.play();
        
        }
      })
      return player;
    }
  })
}

function videoBlockPopup() {
  $('.video-block.video-block--popup .video').each(function () {
    const videoElement = $(this).get(0)
    let poster = $(this).data('poster');
    let player = false;
    if ($(this).hasClass('video--oembed')) {
      player = new Plyr(videoElement, {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        autoplay: false,
        vimeo: { autoplay: false },
        youtube: { autoplay: false },
        fullscreen: { enabled: false }
      })

      if (poster) player.poster = poster;
      //return player
    } else {
      player = new Plyr($(this).get(0), {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        autoplay: false,
        vimeo: { autoplay: false },
        youtube: { autoplay: false },
        fullscreen: { enabled: false }
      });
      if (poster) player.poster = poster;
      //return player;
    }
    // Customize the Plyr controls
    player.on('ready', () => {

      $('.popup-close').on('click', function () {
        player.pause()
      })
      $('.popup').on('click', function (event) {
        // Check if the click occurred outside of .modal-content
        if (!$(event.target).closest('.popup-content').length) {
          player.pause()
        }
      })

      $('.video').on('click touchstart', function (event) {
        event.preventDefault()
        event.stopPropagation()
        if (player.paused) {
          player.play()
        } else {
          player.pause()
        }
      })


    })
  })
}

function videoOrganizations() {
  const plyrElement = document.querySelector('.plyr')

  // Check if the Plyr element exists before creating the observer
  if (plyrElement) {
    const visibleObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const isPaused = $(plyrElement).hasClass('plyr--paused')
        $(plyrElement).find('.video').toggleClass('paused', isPaused)
        $(plyrElement).find('.custom-play').toggleClass('hide', !isPaused)
      })
    })

    // Configure the observer to watch for changes in attributes and child elements
    const observerConfig = { attributes: true, childList: true, subtree: true }

    // Start observing the Plyr element
    visibleObserver.observe(plyrElement, observerConfig)
  }
  // Loader animation
  // const videoBlock = document.querySelector('.videoOrganizations')
  // const loaderBlock = document.querySelector('.loader-block')

  // window.addEventListener('load', function () {
  //   loaderBlock.style.display = 'none'
  //   videoBlock.style.display = 'flex'
  //   videoBlock.play()
  // })
}


export { videoBlock, videoOrganizations, videoBlockPopup };
